module.exports = __webpack_public_path__ + "static/media/DSC04194.5909177b.jpg";